export default "/moocrvUSD-USDT.f3ead6d45a78a369729ecbe354cdef3c.png";